<template>
  <rabbey-base-drawer
    :title="title"
    size="70%"
    :drawer.sync="drawer"
    :before-close="handleClose"
  >
    <el-row :gutter="5">
      <el-col :span="6">
        <span class="text-span"
          >Nombre: <strong>{{ row.Name }}</strong></span
        >
      </el-col>
      <el-col :span="4">
        <span class=""
          >Codigo: <strong>{{ row.No }}</strong></span
        >
      </el-col>
      <el-col :span="8">
        <span>Filto de facturas: </span>
        <div class="filter-currency">
          <el-radio-group
            v-model="radioCurrency"
            size="small"
            @change="trasformDataByCurrency"
          >
            <el-radio-button label="1">Todos</el-radio-button>
            <el-radio-button label="2">Pesos DO</el-radio-button>
            <el-radio-button label="3">Dolar USD</el-radio-button>
          </el-radio-group>
        </div>
        <!-- <span class="name">Filtra: <strong>Dolar</strong></span> -->
      </el-col>
      <el-col :span="6">
        <span class="name"
          >Saldo Pendiente:
          <strong>{{
            formatterMoneyWithCurrency(totalExpiration, "")
          }}</strong></span
        >
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-table3
          ref="table"
          :loading="loading"
          :pageSizes="pageSizes"
          :data="dataFilter"
          :columns="columns"
        >
        </rabbey-table3>
      </el-col>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import { formatterMoneyWithCurrency } from "@/utils";
export default {
  data() {
    return {
      drawer: false,
      loading: false,
      totalExpiration: 0,
      row: {},
      params: {},
      data: [],
      dataFilter: [],
      pageSizes: [50, 100],
      radioCurrency: "1",
      columns: [
        {
          prop: "DocumentNo",
          label: "Numero Documento",
          align: "left",
          width: "150"
        },
        {
          prop: "DueDate",
          label: "Fecha vencimiento",
          formatter: DatetimeFormatter,
          align: "center",
          width: "250"
        },
        {
          prop: "Amount",
          label: "Monto",
          formatter: (row) =>
            formatterMoneyWithCurrency(row.Amount, row.Currency),
          align: "right",
          width: "150"
        },
        {
          prop: "Description",
          label: "Descripcion",
          align: "right"
        }
      ]
    };
  },
  methods: {
    formatterMoneyWithCurrency,
    show(obj) {
      this.row = null;
      this.row = obj.props.row;
      this.totalExpiration = obj.props.rowValue;
      this.params = {
        No: this.row.No,
        TypeExpiration: obj.props.column,
        Anio: obj.year,
        Type: obj.activeTab
      };

      this.getAccountsPayableDetail();
      this.drawer = true;
    },
    handleClose(done) {
      this.radioCurrency = "1";
      this.loading = false;
      done();
    },
    getAccountsPayableDetail() {
      this.loading = true;

      this.$http
        .get("/api/invoices/GetAccountsPayableDetail", {
          timeout: 99999999,
          params: this.params
        })
        .then(({ data }) => {
          this.data = data;
          this.dataFilter = data;
        });

      this.loading = false;
    },
    trasformDataByCurrency(value) {
      this.loading = true;
      this.totalExpiration = 0;

      switch (value) {
        case "1":
          this.dataFilter = this.data;
          break;
        case "2":
          this.dataFilter = this.data.filter((x) => x.Currency.trim() == "");
          break;
        case "3":
          this.dataFilter = this.data.filter((x) => x.Currency.trim() == "USD");
          break;
      }

      for (const value of this.dataFilter) {
        this.totalExpiration +=
          value.Currency == "USD" ? value.Amount * value.Dollar : value.Amount;
      }

      this.loading = false;
    }
  }
};
</script>

<style>
.text-span {
  font-size: 19px;
  margin-left: 3px;
}

.filter-currency {
  display: inline-block;
  margin-left: 4px;
}
</style>
